var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Faq',_vm._b({},'Faq',_vm.componentData,false))
}
var staticRenderFns = []

export { render, staticRenderFns }